import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const HolidaysPurchaseCancelOffer = lazyWithPreload(
  () => import('./HolidaysPurchaseCancelOffer'),
)
